import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';

import { SENTRY_DSN } from './config';
import { store } from './store';

import './styles/global.scss';
import RoutesByType from './routing/RoutesByType';
import { AuthProvider } from './context/AuthProvider';

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    environment: 'production',
  });
}

const isLocalBuild = process.env.CI_ENV === 'local';

const rootContainer = document.getElementById('root');

if (rootContainer) {
  const root = createRoot(rootContainer);

  root.render(
    <AuthProvider>
      <Provider store={store}>
        {isLocalBuild ? (
          <StrictMode>
            <RoutesByType />
          </StrictMode>
        ) : (
          <RoutesByType />
        )}
      </Provider>
    </AuthProvider>,
  );
}
